import React, { useEffect, useState } from "react";
import { wmsApi, fmtKg, fmtKg2 } from "./wmsApi";
import { WCard, WBadge } from "./WmsUi";

export default function WmsMassBalance() {
  const [data, setData] = useState(null);

  useEffect(() => { wmsApi.get("/wms/mass-balance").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <p className="text-zinc-500 py-8">Caricamento...</p>;
  const t = data.totals;
  const ok = Math.abs(t.delta) < 0.001;

  return (
    <div className="space-y-5">
      <h1 className="font-['Chivo'] font-black text-3xl tracking-tighter uppercase">Bilancio di massa</h1>

      <div className={`border-4 p-5 md:p-8 ${ok ? "border-green-600 bg-green-50" : "border-red-600 bg-red-50"}`} data-testid="balance-banner">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-['Chivo'] font-black text-2xl md:text-4xl tracking-tight">
          <span>{fmtKg2(t.in)} <span className="text-sm font-bold text-zinc-500">IN</span></span>
          <span className="text-zinc-400">+</span>
          <span>{fmtKg2(t.adj)} <span className="text-sm font-bold text-zinc-500">RETT.</span></span>
          <span className="text-zinc-400">−</span>
          <span>{fmtKg2(t.out)} <span className="text-sm font-bold text-zinc-500">OUT</span></span>
          <span className="text-zinc-400">−</span>
          <span>{fmtKg2(t.stock)} <span className="text-sm font-bold text-zinc-500">GIACENZA</span></span>
          <span className="text-zinc-400">=</span>
          <span className={ok ? "text-green-700" : "text-red-700"} data-testid="balance-delta">{fmtKg(t.delta)}</span>
        </div>
        <p className={`mt-2 font-bold uppercase text-sm ${ok ? "text-green-700" : "text-red-700"}`}>
          {ok ? "✓ Tutto torna a zero — bilancio quadrato" : "⚠ Bilancio NON quadrato: verifica i lotti in rosso"}
        </p>
      </div>

      <div className="overflow-x-auto border-2 border-zinc-300 bg-white">
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-zinc-950 text-white">
            <tr>
              {["Lotto", "Articolo", "Categoria", "Bolla kg", "IN kg", "Rett. kg", "OUT kg", "Giacenza kg", "Delta"].map((h) => (
                <th key={h} className="text-left px-3 py-3 font-bold uppercase text-xs tracking-wide">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-100">
            {data.rows.map((r) => {
              const rok = Math.abs(r.delta) < 0.001;
              const bolla_diff = r.expected_kg != null ? +(r.kg_in - r.expected_kg).toFixed(3) : null;
              return (
                <tr key={r.lot_id} className={rok ? "" : "bg-red-50"} data-testid={`balance-row-${r.internal_lot}`}>
                  <td className="px-3 py-2.5 font-mono font-bold">{r.internal_lot}<br /><span className="text-xs text-zinc-400 font-normal">{r.lot_supplier || ""}</span></td>
                  <td className="px-3 py-2.5">{r.product_name}<br /><span className="text-xs text-zinc-400 font-mono">{r.product_code}</span></td>
                  <td className="px-3 py-2.5"><WBadge tone="dark">{r.category_name || "—"}</WBadge></td>
                  <td className="px-3 py-2.5">
                    {r.expected_kg != null ? fmtKg2(r.expected_kg) : "—"}
                    {bolla_diff != null && Math.abs(bolla_diff) > 0.005 && <span className="text-amber-700 font-bold"> ({bolla_diff > 0 ? "+" : ""}{fmtKg(bolla_diff)})</span>}
                  </td>
                  <td className="px-3 py-2.5 font-bold">{fmtKg(r.kg_in)}</td>
                  <td className="px-3 py-2.5">{fmtKg(r.kg_adj)}</td>
                  <td className="px-3 py-2.5">{fmtKg(r.kg_out)}</td>
                  <td className="px-3 py-2.5 font-bold">{fmtKg(r.kg_stock)}</td>
                  <td className={`px-3 py-2.5 font-['Chivo'] font-black ${rok ? "text-green-700" : "text-red-700"}`}>{fmtKg(r.delta)}</td>
                </tr>
              );
            })}
            {data.rows.length === 0 && <tr><td colSpan={9} className="px-3 py-8 text-center text-zinc-500" data-testid="balance-empty">Nessun movimento registrato.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
